module.exports = __webpack_public_path__ + "img/newest.2c0fdea8.svg";